import type {
  ChargerFlowsResponse,
  ChargerFlow,
  CreateUpdateChargerFlowBody,
} from '@models/chargerFlows';

import { apiClient } from '@api/client';

export async function getAllChargerFlows(page: number): Promise<ChargerFlowsResponse> {
  const { data } = await apiClient.get<ChargerFlowsResponse>('/charger-flows', {
    params: {
      page,
      limit: 100,
    },
  });

  return data;
}

export async function getChargerFlowById(flowId: string): Promise<ChargerFlow> {
  const { data } = await apiClient.get<ChargerFlow>(`/charger-flows/${flowId}`);

  return data;
}

export async function createChargerFlow(
  chargerFlow: CreateUpdateChargerFlowBody,
): Promise<ChargerFlow> {
  const { data } = await apiClient.post<ChargerFlow>('/charger-flows', chargerFlow);

  return data;
}

export async function updateChargerFlow(
  flowId: string,
  chargerFlow: CreateUpdateChargerFlowBody,
): Promise<ChargerFlow> {
  const { data } = await apiClient.put<ChargerFlow>(`/charger-flows/${flowId}`, chargerFlow);

  return data;
}
